import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createSlots as _createSlots, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "p-the-header-navi-on-admin" }
const _hoisted_2 = { class: "p-the-header-navi-on-admin__item" }
const _hoisted_3 = { class: "p-the-header-navi-on-admin__navi" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconPoint = _resolveComponent("IconPoint")!
  const _component_IconBase = _resolveComponent("IconBase")!
  const _component_NaviListLinkOnAdmin = _resolveComponent("NaviListLinkOnAdmin")!
  const _component_TheHeaderNaviChildOnAdmin = _resolveComponent("TheHeaderNaviChildOnAdmin")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("ul", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.naviList, ({
            label,
            url,
            iconComponentName,
            childList,
            dividingLine,
            hasNotification
          }, key) => {
          return (_openBlock(), _createElementBlock("li", {
            key: key,
            class: _normalizeClass(["p-the-header-navi-on-admin__navi__item", _ctx.dividingLineClassName(dividingLine)])
          }, [
            _createVNode(_component_NaviListLinkOnAdmin, {
              url: url,
              "current-element-key": key,
              "icon-component-name": iconComponentName,
              "child-list": childList,
              "thanks-point-count": _ctx.thanksPointCount,
              shown: _ctx.shownChildItemState(key),
              "has-notification": hasNotification,
              onOnClick: _ctx.onClickDropdown
            }, _createSlots({
              label: _withCtx(() => [
                _createTextVNode(_toDisplayString(label), 1)
              ]),
              _: 2
            }, [
              (iconComponentName === 'IconPoint')
                ? {
                    name: "icon",
                    fn: _withCtx(() => [
                      _createVNode(_component_IconPoint, {
                        "icon-size": 24,
                        "icon-type": 'default',
                        "icon-color": '#616161',
                        "border-color": _ctx.hoverColor[_ctx.isHover(key)]
                      }, null, 8, ["border-color"])
                    ]),
                    key: "0"
                  }
                : {
                    name: "icon",
                    fn: _withCtx(() => [
                      _createVNode(_component_IconBase, {
                        width: 24,
                        height: 24,
                        "view-box": "0 0 24 24",
                        "icon-color": "transparent"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(), _createBlock(_resolveDynamicComponent(iconComponentName), {
                            "icon-color": _ctx.hoverColor[_ctx.isHover(key)],
                            "border-color": _ctx.hoverColor[_ctx.isHover(key)]
                          }, null, 8, ["icon-color", "border-color"]))
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    key: "1"
                  }
            ]), 1032, ["url", "current-element-key", "icon-component-name", "child-list", "thanks-point-count", "shown", "has-notification", "onOnClick"]),
            childList
              ? (_openBlock(), _createBlock(_component_TheHeaderNaviChildOnAdmin, {
                  key: 0,
                  "child-list": childList,
                  "thanks-point-count": _ctx.thanksPointCount,
                  shown: _ctx.shownChildItemState(key)
                }, null, 8, ["child-list", "thanks-point-count", "shown"]))
              : _createCommentVNode("", true)
          ], 2))
        }), 128))
      ])
    ])
  ]))
}